import React from 'react';
import { motion } from 'framer-motion';
import { FadeIn } from './FadeIn';
export function HeroSection() {
  return <section id="home" className="relative min-h-screen flex items-center justify-center overflow-hidden bg-rhino-black pt-20" data-id="element-99">
      {/* Background Image */}
      <div className="absolute inset-0" data-id="element-100">
        <img src="https://cdn.magicpatterns.com/uploads/dUr1zVjET8f8eS1pyCRf18/1000081017.jpg" alt="" className="w-full h-full object-cover" data-id="element-101" />
      </div>
      <div className="absolute inset-0 bg-rhino-black/70" data-id="element-102"></div>
      <div className="absolute inset-0 bg-gradient-to-b from-rhino-black/40 via-transparent to-rhino-black" data-id="element-103"></div>

      {/* Logo watermark */}
      <div className="absolute right-0 bottom-0 opacity-[0.07] pointer-events-none transform translate-x-1/4 translate-y-1/4" data-id="element-104">
        <img src="https://cdn.magicpatterns.com/uploads/k32AHgZ5QWqakPbqyEoYha/4bfafa20-dc71-4720-a5fb-1cff6c6dca54.png" alt="" className="w-[600px] md:w-[800px] h-auto brightness-200 invert" data-id="element-105" />
      </div>

      <div className="container mx-auto px-6 relative z-10 flex flex-col items-center text-center" data-id="element-106">
        <FadeIn delay={0.1} data-id="element-107">
          <h1 className="text-5xl md:text-7xl lg:text-8xl font-heading font-bold text-white leading-tight mb-6 tracking-tight" data-id="element-108">
            THE BOOK THAT <br className="hidden md:block" data-id="element-109" />
            <span className="text-transparent bg-clip-text bg-gradient-to-r from-rhino-gold to-yellow-200" data-id="element-110">
              IGNITES THE CHARGE.
            </span>
          </h1>
        </FadeIn>

        <FadeIn delay={0.3} data-id="element-111">
          <p className="text-xl md:text-2xl text-gray-300 font-medium max-w-2xl mx-auto mb-10" data-id="element-112">
            Discipline. Strength. Purpose. The charge starts now.
          </p>
        </FadeIn>

        <FadeIn delay={0.5} className="flex flex-col sm:flex-row gap-4 w-full sm:w-auto" data-id="element-113">
          <motion.a href="#rhino-mind" whileHover={{
          scale: 1.05
        }} whileTap={{
          scale: 0.95
        }} className="px-8 py-4 bg-rhino-gold text-rhino-black font-heading font-bold text-lg tracking-wider uppercase rounded shadow-[0_0_20px_rgba(212,160,23,0.3)] hover:shadow-[0_0_30px_rgba(212,160,23,0.5)] hover:bg-rhino-gold-hover transition-all" data-id="element-114">
            Follow the Movement
          </motion.a>
          <motion.a href="#community" whileHover={{
          scale: 1.05
        }} whileTap={{
          scale: 0.95
        }} className="px-8 py-4 bg-transparent border-2 border-rhino-gold text-rhino-gold font-heading font-bold text-lg tracking-wider uppercase rounded hover:bg-rhino-gold/10 transition-all" data-id="element-115">
            Join The Rhino Crash
          </motion.a>
        </FadeIn>

        <FadeIn delay={0.8} className="mt-24" data-id="element-116">
          <p className="text-rhino-gold/70 italic font-serif text-lg max-w-xl mx-auto border-l-2 border-rhino-gold/30 pl-4 text-left" data-id="element-117">
            "Let us run with perseverance the race marked out for us." <br data-id="element-118" />
            <span className="text-sm font-sans not-italic text-gray-500 mt-2 block" data-id="element-119">
              — Hebrews 12:1
            </span>
          </p>
        </FadeIn>
      </div>
    </section>;
}